export default "__VITE_ASSET__Bf$CA3yK__"